import React, { Component } from 'react';
import Banner from '../Common/Banner';

import Slider from 'react-slick';

import DocumentMeta from 'react-document-meta';

class About extends React.Component {
	render() {

		var settings = {
			dots: true,
			autoplay:true,
			infinite: true,
			speed: 500,
			slidesToShow: 2,
			slidesToScroll: 1,

			responsive: [{
				breakpoint: 992,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}]
		};

		const meta = {
            title:          'Vi tilbyder overkommelige og pålidelige cykelreparationer og salg',
            description:    'Vi skræddersyer cykler efter din personlige behov og smag. Vores medarbejder har 15 års erfaring fra både Tyskland og Sverige, som har fokus på kvalitet, design og funktion af alle vores produkter.',
            canonical:      window.location.href,
            meta: {
                charset:    'utf-8',
                name: {
                    keywords: 'cykler københavn, cykel reparation københavn, alaska cykler, nøgle maker københavn'
                }
            }
        };

		return (
			<div className="main-content" id="about-page">
                
                <DocumentMeta {...meta} />

				<Banner 
					pageName='Om Os' 
					pageID='about' 
					pageDesc='Vi tilbyder overkommelige og pålidelige cykelreparationer og salg' 
					url='http://res.cloudinary.com/dttrnjoc5/image/upload/c_fill,h_600,q_60,w_1000/v1509207869/backgrounds/slider.jpg' />

				<div className="scroll-stop"></div>

				<div className="t-row">
					<div className="t-col-50 top hidden-xs">
						<img className="background" src="https://res.cloudinary.com/dttrnjoc5/image/upload/v1509207870/backgrounds/about-1.png" />
					</div>
					<div className="t-col-50 top">
						<div className="big-pad">
							<h3 className="sec-head">Om os</h3>
							<p>Hos Alaska cykler åbner vi dørene for en ny verden af cykelkultur.<br /> Vi er et land af verden hvor der er flest cyklister, derfor </p>
							
							<h3 className="sec-head">Vi elsker cykler</h3>
							<p>Vi skræddersyer cykler efter din personlige behov og smag.<br /> Vores medarbejder har 15 års erfaring  fra både Tyskland og Sverige, som har fokus på kvalitet, design og funktion af  alle vores produkter.</p>

							<h3 className="sec-head">Vores viden- din styrke</h3>
							<p>Vi hjælper gerne bedst muligt for at vælge den cykel som kan opfylde din drøm. Vi vælger vores sortiment forsigtigt og tester produkterne, alt for at få dig til at føle dig tryg ved dit køb.<br />Vi tilbyder en lang række reparationer i vores moderne værksted, hvor jeres brugte cykler kan repareres, lappes og eftersynes af vores erfarne medarbejdere, nemt og bekvemt.<br />Du kan reparere eller købe sprint ny cykel samt vælge forskellige tilbehør til din cykel. Vi har et bredt sortiment af moderne og klassiske  kurve, lygter samt hjelm og andre tilbehør.</p>

						</div>
					</div>
				</div>



				<div className="bg-color-default" >
					<div className="container why-us-box-container">
						<header className="header header-main text-left row">
	                        <h2 className="col-md-12 text-left">
	                        	hvorfor vælge os
	                        	<p>Der er mange gode grunde for at vælge os, fordi hos os er der tre forskellige services under et tag.</p>
	                        </h2>
	                    </header>
						<div className="row">
							<div className="col-xs-12 col-sm-6 col-md-4">
								<div className="why-us-box-wrapper">
									<div className="icon">
										<i className="pe-7s-star"></i>
									</div>
									<div className="details">
										<h4>Den Bedste I Klassen</h4>
										<p>Hos  Alaska cykler tilbyder vi et bredt sortiment af kvalitetscykler og cykeltilbehør til  rimelige priser.</p>
									</div>
								</div>
							</div>
							<div className="col-xs-12 col-sm-6 col-md-4">
								<div className="why-us-box-wrapper">
									<div className="icon">
										<i className="pe-7s-tools"></i>
									</div>
									<div className="details">
										<h4>Cykel Reparation</h4>
										<p>Vi reparerer dine cykel med en kærlig hånd og genopfrisker den, så kan den klare det danske vejr.</p>
									</div>
								</div>
							</div>
							
							<div className="visible-sm hidden-md hidden-lg clearfix"></div>

							<div className="col-xs-12 col-sm-6 col-md-4">
								<div className="why-us-box-wrapper">
									<div className="icon">
										<i className="pe-7s-bicycle"></i>
									</div>
									<div className="details">
										<h4>Cykeludlejning</h4>
										<p>Der er også en mulighed for at låne en cykel hvis dine cykel er på vores værksted eller du mangler bare en ekstra cykel for nogle dage.</p>
									</div>
								</div>
							</div>

							<div className="clearfix visible-md visible-lg hidden-sm hidden-xs"></div>

							<div className="col-xs-12 col-sm-6 col-md-4">
								<div className="why-us-box-wrapper">
									<div className="icon">
										<i className="pe-7s-lock"></i>
									</div>
									<div className="details">
										<h4>Nøglefremstilling</h4>
										<p>Vi tilbyder nøgleservice og gør din nøgle klar på ingen tid.</p>
									</div>
								</div>
							</div>

							<div className="visible-sm hidden-md hidden-lg clearfix"></div>

							<div className="col-xs-12 col-sm-6 col-md-4">
								<div className="why-us-box-wrapper">
									<div className="icon">
										<i className="pe-7s-smile"></i>
									</div>
									<div className="details">
										<h4>Kvalitetssupport</h4>
										<p>Vi få glæd af at hjælpe dig i forskellige områder for at gøre dine hverdag nemmere.</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>



				<div className="container">
					<header className="header header-main text-left row">
                        <h2 className="col-md-12 text-left">
                        	Brugere Anmeldelser
                        	<p>Hvad vores kunder siger om os?</p>
                        </h2>
                    </header> 

					<div className="row">
						<div className="col-sm-12" style={{overflow: 'hidden'}}>
							
							<div className="testimonial-container">
								<Slider {...settings}>
									
									<div className="testimonial-wrapper">
										<div className="inner">
											 <div className="comments">
											 	<p>
											 		<strong style={{display: 'inline-block', fontSize: '15px', paddingBottom: '5px'}}>
											 			Kvalitetscykler til fornuftige priser
											 		</strong>
										 			
										 			<br />

										 			Jeg har købt Amore damecykel hos Alaska cykler i Oktober måned. Cyklen passer lige til mine ønsker og behov. Jeg er meget tilfreds med den. Tak Alaska cykler, for at tilbyde en super god service.
										 			
										 		</p>
											 	<h4>Ms. Denise</h4>
											 </div> 
											 <div className="image">
											 	<img src="../images/faces/1.jpg" />
											 </div>
										</div>
									</div>
									<div className="testimonial-wrapper">
										<div className="inner">
											 <div className="comments">
											 	<p>
											 		<strong style={{display: 'inline-block', fontSize: '15px', paddingBottom: '5px'}}>
											 			Hurtig og serviceminded
											 		</strong>
										 			
										 			<br />

										 			Jeg fik repareret min cykel hos Alaska cykler i sidste måned. Min cykel trængte til en eftersyn, jeg valgte Alaska cykler. Jeg var positivt overrasket over at få min cykel tilbage til tiden samt jeg fik lavet lidt ekstra services helt gratis ved siden af. Hurtig og rar service. Helt klart, mit valg bliver Alaska cykler igen og igen.

										 		</p>
											 	<h4>Ms. Natasha</h4>
											 </div> 
											 <div className="image">
											 	<img src="../images/faces/2.jpg" />
											 </div>
										</div>
									</div>
									<div className="testimonial-wrapper">
										<div className="inner">
											 <div className="comments">
											 	<p>
											 		<strong style={{display: 'inline-block', fontSize: '15px', paddingBottom: '5px'}}>
											 			God oplevelse
											 		</strong>
										 			
										 			<br />

										 			Købte Van De Falk Classic cykel for to måneder siden. Kvaliteten er op på toppen samt en overkommelig pris. Betjening er rar, ærlig og professionel.

										 		</p>
											 	<h4>Ms. Moly</h4>
											 </div> 
											 <div className="image">
											 	<img src="../images/faces/3.jpg" />
											 </div>
										</div>
									</div>
									<div className="testimonial-wrapper">
										<div className="inner">
											 <div className="comments">
											 	<p>
											 		<strong style={{display: 'inline-block', fontSize: '15px', paddingBottom: '5px'}}>
											 			Gode tilbud på cykler
											 		</strong>
										 			
										 			<br />

										 			Priser og service er i orden, smilende betjening og rådgivning. De har god tilbud på kvalitetscykler altid. Derfor kan de kun anbefales.
										 			
										 		</p>
											 	<h4>Ms. Sara</h4>
											 </div> 
											 <div className="image">
											 	<img src="../images/faces/4.jpg" />
											 </div>
										</div>
									</div>
								</Slider>
							</div>

						</div>
					</div>
				</div>

			</div>
		);
	}
}

export default About;



// WEBPACK FOOTER //
// ./src/Pages/About.js